module.exports = __webpack_public_path__ + "static/img/home5.d2e50b20.png";